import React from 'react'
import { Chip } from 'primereact/chip'
import './data.scss'
import { getContrast } from '../../utils/text-color'

type ChipFilteredContentProps = {
    /**
     * if assigned a value it'll be displayed, otherwise (at least for the time being) its default value's "SGH"
     */
    label: string
    /**
     * if not assigned, it'll be displayed the defaultBackgroundColor's value
     */
    backgroundColor?: string
    /**
     * if not added, it'll only display "_style" 's rules
     */
    style?: object
}

const ChipFilteredContent = ({
    label,
    backgroundColor,
    style,
}: ChipFilteredContentProps) => {
    const defaultBackgroundColor = 'var(--lux-paper-secondary)' //light gray colour

    //since it's a local variable used just once in the entire file, it's been called "_style"
    let _style = {
        color: backgroundColor
            ? getContrast(
                  //based on the given background colour,
                  //it calcules the contrast and verifies what colour fits best (as text colour) between black and white
                  backgroundColor
              )
            : 'var(--lux-text-primary)',
        backgroundColor: backgroundColor
            ? backgroundColor
            : defaultBackgroundColor,
        ...style,
    }

    //Reference: https://www.primefaces.org/primereact-v6/#/chip
    return (
        <Chip
            className={'chip-filtered-content-general'}
            style={_style}
            label={label}
        />
    )
}

export default ChipFilteredContent
